import request from '@/utils/request'

//  根据类型获取服务提供商列表
export const lisServiceProvider = (pageData, formData) => {
    return request.get(`/service-provider/page/${pageData.page}/${pageData.pageSize}`, {params: formData})
}
